<template>
  <boat-form />
</template>

<script>
import BoatForm from '@/components/forms/BoatForm'
export default {
  components: {
    BoatForm
  }
}
</script>
